<template>
    <div class="order-card-box">
        <div class="goods-card">
            <div class="title">
                <div class="title-shop" v-if="showDetails">
                    <img :src="logoUrl" alt="" width="20" height="20" v-if="logoUrl.length > 0">
                    <img src="../../assets/images/store.png" alt="" width="20" height="20" v-else>
                    <span>{{ orderInfo.shop }}</span>
                </div>
                <div class="title-shop" v-else>
                    <span class="oid">订单号 {{ orderInfo.oid }}</span>
                    <img src="../../assets/images/copy.png" alt="" width="16" height="16" @click="copyToClipboard(orderInfo.oid)">
                </div>
                <div v-if="orderInfo.status === 'orderPaying'" class="count-down">
                    <van-count-down :time="time" v-show="showCountDown" @finish="finish"/>
                    <span class="status-paying" >待付款</span>
                </div>
                <span class="status-paying" v-else-if="orderInfo.status === 'orderPicking'">待配货</span>
                <span class="status-picking" v-else-if="orderInfo.status === 'orderReceived'">待收货</span>
                <span class="status-picking" v-else-if="orderInfo.status === 'orderRefund'">退款成功</span>
                <span class="status-picking" v-else-if="orderInfo.status === 'orderApplyRefund'">退款中</span>
                <span class="status-cancel" v-else-if="orderInfo.status === 'orderComment'">已完成</span>
                <span class="status-cancel" v-else-if="orderInfo.status === 'orderCommentMonthlyPay'">已收货</span>
                <span class="status-picking" v-else-if="orderInfo.status === 'orderPaid'">已支付</span>
                <span class="status-cancel" v-else-if="orderInfo.status === 'orderCancel'">已取消</span>
                <span class="status-cancel" v-else-if="orderInfo.status === 'orderAutoCancel' && !showDetails">已取消</span>
                <span class="status-cancel" v-else-if="orderInfo.status === 'orderAutoCancel' && showDetails">超时未支付, 已自动取消</span>
                <span class="status-picking" v-else-if="orderInfo.status === 'orderPaidCancel'">退款成功</span>
            </div>
            <div v-if="orderInfo.type !== 'vip' && orderInfo.type !== 'partner'">
                <div class="express-info-picking" v-if="orderInfo.status === 'orderPaying' || orderInfo.status === 'orderPaid' || orderInfo.status === 'orderPicking'">
                    <div class="title">配送信息：</div>
                    <div>当天/次日发货</div>
                </div>
                <div class="express-info-picking" v-else-if="orderInfo.status === 'orderReceived'" @click="goExpressPage">
                    <div class="title">配送信息：</div>
                    <div>物流信息</div>
                </div>
            </div>
            <div class="goods-desc" @click="goOrderDetails(orderInfo.oid)" v-for="(list, index) in orderInfo.lists" :key="index">
                <div class="img">
                    <img :src="list.imgUrl" alt="加载中..." width="100" height="100">
                </div>
                <div class="card-right">
                    <div class="desc-text">{{ list.title }}</div>
                    <div style="height: 10px;" v-if="list.type === 'partner' || list.type === 'vip'"></div>
                    <div :class="[ showDetails ? 'type-text' : 'type-text-collapse']" v-else>{{ list.type }}</div>
                    <div class="price">
                        <div><span>￥</span>{{ list.price }}</div>
                        <div style="color:#969699;font-size: 14px;">共{{ list.amount }}个</div>
                    </div>
                </div>
            </div>
            <div v-if="showDetails" class="show-details">
                <div class="ticket">
                    <div>发票信息</div>
                    <div class="ticket-text">不支持自助开票，请联系客服</div>
                </div>
                <div class="price">
                    <div class="total-price">
                        <div>商品总价:</div>
                        <div>￥ {{ orderInfo.totalPrice }}</div>
                    </div>
                    <!-- <div class="discount-price">
                        <div>优惠:</div>
                        <div>– ￥ {{ orderInfo.discountPrice }}</div>
                    </div> -->
                    <div class="express-charge">
                        <div>运费:</div>
                        <div v-if="Number(orderInfo.expressCharge) > 0">￥ {{ orderInfo.expressCharge }}</div>
                        <div v-else>免运费</div>
                    </div>
                    <!-- <div class="call-owner">
                        <div>联系卖家</div>
                        <div class="divider">|</div>
                        <div>投诉卖家</div>
                    </div> -->
                </div>
            </div>
            <div class="price-row" v-if="orderInfo.status !== 'orderRefund' && orderInfo.status !== 'orderPaidCancel' && !showDetails">
                <div class="amount">共{{ orderInfo.lists.length }}款</div>
                <div class="price">
                    <!-- <span class="price-grey">总价 ￥{{ orderInfo.totalPrice }}</span> -->
                    <!-- <span class="price-grey">优惠 ￥{{ orderInfo.discountPrice }}</span> -->
                    <span>实付 ￥{{ orderInfo.finalPayPrice }}</span>
                </div>
            </div>
            <div class="button-group" v-show="showButton">
                <div class="button-pay" v-if="orderInfo.status === 'orderPaying'" @click="pay">立即支付</div>
                <div class="button" v-else-if="orderInfo.status === 'orderPicking' || orderInfo.status === 'orderPaid'" @click="expedited">催包裹</div>
                <div class="button-pay" v-else-if="orderInfo.status === 'orderReceived'" @click="handleReceived">确认收货</div>
                <div class="button" v-else-if="orderInfo.status === 'orderRefund' || orderInfo.status === 'orderPaidCancel'" @click="handleDetails(orderInfo.oid)">查看详情</div>
                <div class="button" v-else-if="orderInfo.status === 'orderComment' || orderInfo.status === 'orderCommentMonthlyPay'" @click="handleRebuy">再次购买</div>
                <div v-else-if="orderInfo.status === 'orderCancel' || orderInfo.status === 'orderAutoCancel'" style="display: flex;">
                    <div class="button" @click="deleteOrder">删除订单</div>
                    <div class="button" @click="handleRebuy">再次购买</div>
                </div>
            </div>
        </div>
        <div v-if="showDetails" class="show-details-pay">
            <div class="final-pay-price">
                <div>实付：</div>
                <div>￥ {{ orderInfo.finalPayPrice }}</div>
            </div>
            <div class="pay-desc">
                <div class="row" v-if="orderInfo.status !== 'orderPaying' && orderInfo.status !== 'orderAutoCancel' && orderInfo.status !== 'orderCancel'">支付方式：{{ orderInfo.payment ? orderInfo.payment : '微信' }}</div>
                <div class="row">
                    <span>订单编号：{{ orderInfo.oid }}</span>
                    <img src="../../assets/images/copy.png" alt="" width="16" height="16" @click="copyToClipboard(orderInfo.oid)">
                </div>
                <div class="row">
                    下单时间：{{ orderInfo.createAt }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import { Toast } from 'vant'

export default {
  name: 'OrderCard',
  components: {
  },
  created(){

  },
  mounted(){
    this.setCountDown()
  },
  updated(){
    this.setCountDown()
  },
  data:()=>{
    return {
        time: 0,
        showCountDown: true
    }
  },
  methods:{
    goOrderDetails(oid){
        this.$router.push({path:'/order-desc', query: { oid: oid, tabId: this.tabId }})
    },
    finish(){
        this.showCountDown = false
    },
    deleteOrder(){
        this.$emit('deleteOrder', this.orderInfo.oid)
    },
    pay(){
        this.$emit('pay', this.orderInfo.oid)
    },
    handleReceived(){
        this.$emit('received', this.orderInfo.oid)
    },
    handleDetails(oid){
        this.$router.push({path:'/order-desc', query: { oid: oid, tabId: this.tabId }})
        // Toast('完善中,请谅解~')
    },
    handleRebuy(){
        // this.$emit('received', this.orderInfo.oid)
        Toast('完善中,请谅解~')
    },
    expedited(){
        this.$emit('expedited', this.orderInfo.oid)
    },
    goExpressPage(){
        this.$emit('goExpressPage', this.orderInfo.oid, this.orderInfo.waybill)
    },
    // 复制到剪切板
    copyToClipboard(text) {
        const textarea = document.createElement("textarea"); // 创建一个textarea元素
        textarea.value = text; // 设置textarea的值
        document.body.appendChild(textarea); // 将textarea添加到DOM中
        textarea.select(); // 选中textarea中的文本
        document.execCommand("copy"); // 将选中的文本复制到剪贴板中
        document.body.removeChild(textarea); // 从DOM中移除textarea
        Toast('已复制');
    },
    setCountDown(){
        if(this.orderInfo.status === 'orderPaying'){
            const momentGivenTime = moment(this.orderInfo.createAt, 'YYYY-MM-DD HH:mm:ss');
            const now = moment();
            const differenceInMinutes = now.diff(momentGivenTime, 'minutes');
            if (differenceInMinutes < 15) {
                this.time = 15 * 60 * 1000 - differenceInMinutes * 60 * 1000
            } else {
                this.time = 0
            }
        }
    }
  },
  props:{
    orderInfo:{
        type: Object,
        default: ()=>{}
    },
    showButton:{
        type: Boolean,
        default: true
    },
    showDetails:{
        type: Boolean,
        default: false
    },
    tabId:{
        type: String,
        default: '0'
    },
    logoUrl:{
        type: String,
        default: ''
    }
  }
}
</script>

<style scoped lang="scss">
.order-card-box {
    .goods-card {
        background: #fff;
        margin: 10px;
        border-radius: 20px;
        .title {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 15px;
            font-size: 15px;
            .title-shop {
                display: flex;
                align-items: center;
                img {
                    border-radius: 2px;
                    margin: 0 5px;
                }
                .oid {
                    color: #969699;
                }
            }
            .count-down {
                display: flex;
                align-items: baseline;
                span {
                    margin-left: 5px;
                }
            }
            .status-paying {
                font-size: 15px;
                color: #f0061d;
            }
            .status-picking {
                font-size: 15px;
                color: #ffd700;
            }
            .status-cancel {
                font-size: 15px;
                color: #969699
            }
        }
        .express-info {
            display: flex;
            background: #f3f3f3;
            padding: 5px 0;
            margin: 0 15px 20px;
            font-size: 14px;
            border-radius: 5px;
            text-align: left;
            .title {
                padding: 0 10px 0 10px;
            }
        }
        .express-info-picking {
            display: flex;
            justify-content: space-between;
            align-items: center;
            background: #f3f3f3;
            padding: 5px 10px;
            margin: 0 15px 20px;
            font-size: 14px;
            border-radius: 5px;
            .title {
                padding: 0;
            }
        }
        .goods-desc {
            display: flex;
            position : relative;
            padding: 0 10px 0px;
            margin: 10px 0;
            .img {
                width: 100px;
                height: 100px;
                margin: 0 0 0 10px;
                background: #fafafa;
            }
            img {
                border-radius: 2px;
            }
            .card-right {
                flex: 1;
                padding: 0 0px 0 10px;
                text-align: left;
                word-break: break-all;
                .desc-text {
                    font-size: 17px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 1;
                    -webkit-box-orient: vertical;
                }
                .type-text {
                    font-size: 15px;
                    padding: 0;
                }
                .type-text-collapse {
                    font-size: 15px;
                    margin: 5px 0 0;
                    padding: 0;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 1;
                    -webkit-box-orient: vertical;
                }
                .price {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    font-size: 18px;
                    // font-weight: 600;
                    padding: 5px 15px 10px 0;
                    span {
                        font-size: 16px;
                    }
                }
            }
        }
        .show-details {
            text-align: left;
            margin: 0 15px;
            font-size: 15px;
            .ticket {
                border-top: 1px rgba(0,0,0,0.05) solid;
                border-bottom: 1px rgba(0,0,0,0.05) solid;
                margin: 10px 0;
                padding: 10px 5px;
                .ticket-text {
                    padding: 5px 0;
                    color: #969699;
                }
            }
            .price {
                .total-price {
                    display: flex;
                    justify-content: space-between;
                    padding: 0 5px 5px;
                }
                .discount-price {
                    display: flex;
                    justify-content: space-between;
                    padding: 0 5px 5px;
                }
                .express-charge {
                    display: flex;
                    justify-content: space-between;
                    padding: 0 5px 15px;
                }
                .call-owner {
                    display: flex;
                    justify-content: center;
                    border-top: 1px rgba(0,0,0,0.1) solid;
                    padding: 15px 0;
                    .divider {
                        padding: 0 10px;
                    }
                }
            }
        }
        .price-row {
            display: flex;
            justify-content: space-between;
            margin: 15px 15px 0;
            padding: 15px 0 5px;
            border-top: 1px rgba(0,0,0,0.05) solid;
            .amount {
                font-size: 15px;
                min-width: fit-content;
                color: #969699;
            }
            .price {
                display: flex;
                flex-wrap: wrap;
                justify-content: flex-end;
                span {
                    padding: 0 5px;
                    font-size: 15px;
                }
                .price-grey {
                    color: #969699;
                }
            }
        }
        .button-group {
            margin: 0 10px;
            display: flex;
            justify-content: flex-end;
            padding-bottom: 5px;
            .button {
                border: 1px rgba(0,0,0,0.2) solid;
                border-radius: 25px;
                padding: 0 15px;
                font-size: 15px;
                margin: 5px 10px;
                height: 30px;
                line-height: 30px;
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
            }
            .button-pay {
                // border: 1px rgba(0,0,0,0.01) solid;
                // background: #fc5f10;
                background: #29323c;
                border: 1px solid #29323c;
                border-radius: 25px;
                padding: 0 20px;
                font-size: 15px;
                height: 30px;
                line-height: 30px;
                margin: 5px 10px;
                color: #fff;
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
            }
        }
    }
    .show-details-pay {
        text-align: left;
        background: #fff;
        margin: 10px;
        border-radius: 15px;
        padding: 10px 20px;
        font-size: 15px;
        .final-pay-price {
            display: flex;
            padding: 0 0 10px;
            margin: 5px 0 0;
            border-bottom: 1px rgba(0,0,0,0.1) solid;
        }
        .pay-desc {
            padding: 5px 0 0;
            margin: 0 0 5px;
            .row {
                padding: 5px 0;
                display: flex;
                align-items: center;
                img {
                    margin: 0 3px;
                }
            }
        }
    }
}
::v-deep .van-count-down {
    color: #f0061d;
    font-size: 15px;
    line-height: 20px;
}
</style>